import { INumberFilterParams, ValueFormatterParams } from 'ag-grid-enterprise';

export const currencyFilterParams: INumberFilterParams = {
  allowedCharPattern: '\\d\\-\\.\\$',
  numberParser: (text: string | null) => {
    return text == null ? null : parseFloat(text.replace('$', ''));
  },
};
export const currencyValueFormatter = function (params: ValueFormatterParams) {
  const formatted = params.value.toFixed(2);
  if (formatted.indexOf('-') === 0) {
    return '-$' + formatted.slice(1);
  }
  return '$' + formatted;
};
